// Helper function to get badge color based on duration
export function getDurationColor(days: number): string {
  if (days >= 21) return 'red'
  if (days >= 14) return 'orange'
  if (days >= 7) return 'yellow'
  if (days >= 3) return 'blue'
  return 'blue'
}